import { get, post, postJson, serialize } from '../httpClient';

export const listingsAPI = {
  show: params => get('/api/listings/show', params),
  close: body => post('/api/listings/close', serialize(body)),
  open: body => post('/api/listings/open', serialize(body)),
  approve: body => post('/api/listings/approve', serialize(body)),
  update: body => post('/api/listings/update', serialize(body)),
  // The signed-in person, from the session: a listing's metadata is the server's to write.
  joinWaitlist: listingId => postJson(`/api/listings/${listingId}/waitlist/join`),
  leaveWaitlist: listingId => postJson(`/api/listings/${listingId}/waitlist/leave`),
  rate: (listingId, rating) => postJson(`/api/listings/${listingId}/rating`, { rating }),
  sendTeamInvite: body => post('/api/listings/send-team-invite', serialize(body)),
  // Emails of invitees without an account, for whoever manages the listing's team.
  teamInviteEmails: listingId => get('/api/listings/team-invite-emails', { id: listingId }),
};
